import { Feedback } from "../feedback/Feedback.js";
import { getFirstItem } from "../util/array.js";
import { getMap, isMapItem } from "../util/map.js";
import { getString } from "../util/string.js";
import { Schema } from "./Schema.js";
/** Define a valid value from an allowed set of values. */
export class AllowSchema extends Schema {
    allow;
    constructor(options) {
        const allow = getMap(options.allow);
        const value = getFirstItem(allow.keys());
        super({ value, ...options });
        this.allow = allow;
    }
    validate(unsafeValue = this.value) {
        if (isMapItem(this.allow, unsafeValue))
            return unsafeValue;
        throw new Feedback("Unknown value", unsafeValue);
    }
    /** Iterate over the the allowed options in `[key, value]` format. */
    [Symbol.iterator]() {
        return this.allow[Symbol.iterator]();
    }
}
/** Define a valid string value from an allowed set of string values. */
export class AllowStringSchema extends AllowSchema {
    constructor({ allow, ...options }) {
        super({ allow: getMap(allow), ...options });
    }
    validator(unsafeValue = this.value) {
        return super.validate(getString(unsafeValue));
    }
}
/** Valid value from an allowed set of values. */
export function ALLOW(allow) {
    return new AllowSchema({ allow });
}
/** Valid string from an allowed set of values. */
export function ALLOW_STRING(allow) {
    return new AllowStringSchema({ allow });
}
